import { render, staticRenderFns } from "./GroupMembers.tab.vue?vue&type=template&id=823253c0&"
import script from "./GroupMembers.tab.vue?vue&type=script&lang=ts&"
export * from "./GroupMembers.tab.vue?vue&type=script&lang=ts&"
import style0 from "./GroupMembers.tab.vue?vue&type=style&index=0&lang=css&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports